// extracted by mini-css-extract-plugin
export default {"sending":"CustomForm_sending__d-gWi","error":"CustomForm_error__BQai5","success":"CustomForm_success__IGjd-"};